import React, { useState } from 'react';
import i18n from '@i18next/i18n';
import styles from './index.less';
import EditorAnimPreviewManager from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/editor-state-animation/editor-anim-preview-manager';
import Tooltip from '@tencent/dui/lib/components/Tooltip';

const icon = 'data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\'%3E%3Cpath d=\'M12.5 3l1.5.944L5.671 13l-.885-.957L2 9l1.5-1 2.215 2.22z\' fill=\'%231e6fff\' fill-rule=\'evenodd\'/%3E%3C/svg%3E';

const AnimPreviewPanel = () => {
    const previewManager = EditorAnimPreviewManager.getInstance();
    const [isAnimPreviewing, setAnimPreviewing] = useState(previewManager.isAnimPreviewing);
    const [isAutoChosen, setAutoChosen] = useState(previewManager.getAutoPreview());

    const handlePreviewAnim = () => {
        setAnimPreviewing(!isAnimPreviewing);
        if (isAnimPreviewing) {
            previewManager.cancelPreviewingAnims();
        } else {
            previewManager.previewFromBeginning();
        }
    };

    const handleAutoPreview = () => {
        const allowAutoPreview = previewManager.getAutoPreview();
        previewManager.setAutoPreview(!allowAutoPreview);
        setAutoChosen(!allowAutoPreview);
    };
    return (
        <div className={styles['anim-preview-panel']}>
            <div className={styles['anim-preview-panel-item']}>
                <Tooltip title={isAnimPreviewing ? i18n.t('暂停预览') : i18n.t('预览效果')} style={{ width: '100%' }}>
                    <p className={styles['preview-effect']} onClick={handlePreviewAnim}>
                        {isAnimPreviewing ? i18n.t('暂停预览') : i18n.t('预览效果')}
                    </p>
                </Tooltip>
            </div>
            <div className={styles['anim-preview-panel-item']}>
                <Tooltip title={i18n.t('自动预览')} style={{ width: '100%' }}>
                    <div className={styles['auto-preview']} onClick={handleAutoPreview}>
                        <div className={styles['icon-wrapper']}>
                            {isAutoChosen && <img src={icon} className={styles['check-icon']} />}
                        </div>
                        <p className={styles['auto-preview-text']}>{i18n.t('自动预览')}</p>
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};

export default AnimPreviewPanel;
